export default __webpack_public_path__ + "static/kids-grad-right-half-f8f1c2424a938e6b3d409de3eda96a07.svg";